import { create } from 'zustand'
import apiHelper from '@/network/api'

interface KeywordDetails {
  id: string
  memberId: number
  threadsUserId: string
  keyword: string
  searchType: string
  order: number
  updateInterval: number
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  teamId: string
  excludeWords: string[]
}

interface KeywordDetailsState {
  keywordDetails: KeywordDetails | null
  isLoading: boolean
  error: string | null
  isUpdatingExcludeWords: boolean
  fetchKeywordDetails: (id: string, metricDays?: number, excludeWords?: string) => Promise<void>
  updateExcludeWords: (id: string, excludeWords: string[], metricDays: number) => Promise<boolean>
}

const useKeywordDetailsStore = create<KeywordDetailsState>((set, get) => ({
  keywordDetails: null,
  isLoading: false,
  error: null,
  isUpdatingExcludeWords: false,

  fetchKeywordDetails: async (id: string, metricDays: number = 180, excludeWords?: string) => {
    try {
      set({ isLoading: true, error: null })
      const response = await apiHelper(null).get(`keyword/${id}`)
      
      if (response.status === 200) {
        const data = response.data
        set({ 
          keywordDetails: data,
          isLoading: false 
        })
      }
    } catch (error) {
      set({ 
        error: 'Failed to fetch keyword details',
        isLoading: false
      })
      console.error('Error fetching keyword details:', error)
    }
  },

  updateExcludeWords: async (id: string, excludeWords: string[], metricDays: number) => {
    try {
      set({ isUpdatingExcludeWords: true, error: null })
      
      const response = await apiHelper(null).put(
        `keyword/${id}/exclude-words`,
        {
          excludeWords: excludeWords,
        },
        {
          params: {
            metricDays: metricDays,
            excludeWords: excludeWords.join(","),
          },
        }
      )

      if (response.status === 200) {
        // Update the local state with new exclude words
        const currentDetails = get().keywordDetails
        if (currentDetails) {
          set({
            keywordDetails: {
              ...currentDetails,
              excludeWords: excludeWords
            },
            isUpdatingExcludeWords: false
          })
        }
        return true
      }
      
      set({ isUpdatingExcludeWords: false })
      return false
    } catch (error) {
      set({ 
        error: 'Failed to update exclude words',
        isUpdatingExcludeWords: false
      })
      console.error('Error updating exclude words:', error)
      return false
    }
  }
}))

export default useKeywordDetailsStore